import useLocalStorage from '@/hooks/use-local-storage';
import {
  Box,
  BoxProps,
  Button,
  Flex,
  Icon,
  IconButton,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { MdClose } from 'react-icons/md';

const MBox = motion<BoxProps>(Box);

const CookiePolicy = () => {
  const [cookiePolicy, setCookiePolicy] = useLocalStorage<
    'agreed' | 'disagreed' | 'not-decided'
  >(`cookie-policy`, `not-decided`);

  const { isOpen, onClose, onOpen } = useDisclosure();

  useEffect(() => {
    if (cookiePolicy === `not-decided`) {
      setTimeout(onOpen, 1.5 * 1000);
    }
  }, []);
  return (
    <MBox
      initial={{ y: 420 }}
      animate={{ y: isOpen ? 0 : 420 }}
      position="fixed"
      zIndex="toast"
      bottom="0"
      right="0"
      left="0"
    >
      <Flex
        w={[`full`, null, `80%`]}
        bgColor="#f0f0f0"
        borderTopRadius="xl"
        pt="6"
        pb="12"
        position="relative"
        pe={9}
        mx="auto"
        ps={16}
        justify="space-between"
        align="center"
      >
        <IconButton
          size="sm"
          aria-label="close"
          icon={<Icon boxSize="5" as={MdClose} />}
          position="absolute"
          top="4"
          left="3"
          onClick={onClose}
        />

        <Text fontSize="sm">
          Size daha iyi bir alışveriş deneyimi sunabilmek için çerezler
          kullanıyoruz.
          <br />
          Detaylı bilgi için çerez politikamızı ve kişisel verilerin korunması
          hakkında açıklama metnini inceleyebilirsiniz.
        </Text>

        <Flex direction={[`column`, null, null, `row`]}>
          <Button mb={[2, null, null, 0]} colorScheme="blue" variant="ghost">
            Hayir, tesekkurler
          </Button>
          <Button
            onClick={() => {
              setCookiePolicy(`agreed`);
              onClose();
            }}
            ms="2"
            variant="solid-brand-cta"
          >
            Kabul ediyorum
          </Button>
        </Flex>
      </Flex>
    </MBox>
  );
};

export default CookiePolicy;
